import { useMutation } from '@apollo/client'
import { toastSuccess, toastFailure } from 'lib/ui/components/Toast'
import { createReviewMutation } from './utils'

export interface UseCreateReview {
  onSuccess?: () => any
  onSuccessShowToast?: boolean
  onError?: () => any
  onErrorShowToast?: boolean
}

export const useCreateReview = (options?: UseCreateReview) => {
  const handleError = () => {
    options?.onError && options.onError()
    if (options?.onSuccessShowToast) {
      toastFailure({ messageId: 'reviews.submit.error' })
    }
  }

  const handleSuccess = () => {
    options?.onSuccess && options.onSuccess()
    if (options?.onSuccessShowToast) {
      toastSuccess({ messageId: 'reviews.submit.success' })
    }
  }

  const [
    createReview,
    { loading: mutationLoading }
  ] = useMutation(createReviewMutation, { onError: handleError, onCompleted: handleSuccess })

  return {
    createReview: createReview,
    isLoading: mutationLoading
  }
}
